<template>
  <div class="folder-header">
    <v-btn icon
           color="primary"
           @click="$emit('directory-up')"
    >
      <v-icon>mdi-arrow-up</v-icon>
    </v-btn>
    <div class="file-path">
      <v-text-field v-if="currentDirectoryToDisplay"
                    readonly
                    :value="currentDirectoryToDisplay.physicalPath"
      >
      </v-text-field>
      <v-text-field v-if="!currentDirectoryToDisplay"
                    readonly
                    :value="' '"
      >
      </v-text-field>
    </div>
    <div class="entry-search">
      <v-text-field v-model="localSearchEntry"
                    label="Search"
                    class="entry-search"
                    prepend-inner-icon="mdi-magnify"
                    @input="$emit('entry', localSearchEntry)"
      >
      </v-text-field>
    </div>
  </div>
</template>

<script>
export default {
  name:  "FolderHeader",
  props: ['currentDirectoryToDisplay', 'searchEntriesSubject', 'searchEntry'],
  data:  () => ({
    localSearchEntry: null,
  }),
  watch: {
    searchEntry() {
      if (!this.searchEntry) {
        this.localSearchEntry = '';
      }
    }
  }
}
</script>

<style scoped>
.entry-search {
  width: 150px;
}

.folder-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-right: 20px;
  height: 55px;
}

.file-path {
  padding-right: 10px;
  width: 100%;
}
</style>
